export default {"src":"/evde-internet/_next/static/media/chevron-up.9baf7117.svg","height":24,"width":25};